export enum UrmetRequestStatus {
  COMPLETED = "completed",
  PENDING = "pending",
  PROCESSING = "processing",
  ERROR = "error",
}
